import { render, staticRenderFns } from "./returnCard.vue?vue&type=template&id=4562a5a8&scoped=true&"
import script from "./returnCard.vue?vue&type=script&lang=js&"
export * from "./returnCard.vue?vue&type=script&lang=js&"
import style0 from "./returnCard.vue?vue&type=style&index=0&id=4562a5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562a5a8",
  null
  
)

export default component.exports